import React from 'react'

import { AppLocale } from '@procsea/common/utils'
import { Flag, Inline, Label } from '@procsea/design-system'

import { APP_LANGUAGES, COUNTRY_CODES } from 'src/constants/constants'

interface InputLabelProps {
  helpText?: string
  label: string
  locale: AppLocale
  required?: boolean
}

const InputLabel = ({ helpText, label, locale, required = false }: InputLabelProps) => (
  <Inline alignment="flex-start" spacing="xsmall">
    <Label
      data-e2e={`input-label-${locale}`}
      helpText={helpText}
      text={`${label} - ${APP_LANGUAGES[locale]}`}
      required={required}
    />
    <Flag code={COUNTRY_CODES[locale]} />
  </Inline>
)

export default InputLabel
